window.addEventListener('load', function(e) {
    if(typeof dataLayer !== "undefined") {
        if(window.location.pathname == '/') {
            dataLayer.push({
                'event':'page_view_hp',
                'url':window.location.pathname
            });
        } else {
            dataLayer.push({
                'event':'page_view',
                'url':window.location.pathname
            });
        }
    }
});

// Listen all clicks on elements with data-attribute data-trck
document.addEventListener('click', function(e) {
    if(typeof dataLayer !== "undefined") {
        var target = e.target.closest('[data-trck]');
        if(target) {
            clickTracking(target);
        }
    }
});

// GTM event by data-attribute function
function clickTracking(element) {
    var data = element.getAttribute('data-trck');
    if(data) {
        data = JSON.parse(data);
        if(data.hasOwnProperty('fields')) {
            data.fields = getTrackedFields(data.fields);
        }
        console.log(data);
        dataLayer.push(data);
    }
}

function getTrackedFields(fields) {
    var values = {};
    if(!(fields instanceof Array)) {
        fields = [fields];
    }
    fields.forEach(function(field) {
        var el = document.querySelector(field);
        if(el) {
            let name = field.replace(/[.]|#|-/g, ''),
                val = el.value;
            if(el.getAttribute('id') == 'vehicleOwned') {
                val = el.options[el.selectedIndex].text == "Un projet d'achat" ? "projet" : "possede";
            }
            values[name] = val;
            dataLayer.push({
                "event": "selection_"+name+"_"+val.replace(/[.]|#|_|-| /g, '')
            });
        }
    });
    console.log(values);
    return values;
}